<template>
  <div class="mainContent">
    <div class="mainBox">
      <div class="carouselBox">
        <div class="carouselImg1" v-if="cardInfo.length == 0">
          <img class="no-img" src="../../assets/img/swiper_no_img.png" alt="" />
        </div>
        <div class="carouselImg" v-if="cardInfo.length > 0">
          <el-carousel
            :interval="3000"
            arrow="always"
            :autoplay="true"
            height="335px"
            trigger="click"
            indicator-position="none"
          >
            <el-carousel-item v-for="(item, index) in cardInfo" :key="index">
              <div class="slide" @click="tongZhiGongGao(item.UnitGuid)">
                <img :src="item.PicUrl" style="width: 100%; height: 100%" />
                <div class="bar">{{ item.Title }}</div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="carouselList">
          <div class="xwzxTit">
            <ul>
              <li
                @click="toptabClick('800002', 0)"
                :class="{ topactive: topcur == 0 }"
              >
                通知公告
              </li>
              <li
                @click="toptabClick('800005', 1)"
                :class="{ topactive: topcur == 1 }"
              >
                政策法规
              </li>
            </ul>
            <router-link
              target="_blank"
              :to="{ path: '/GongSiDongTai', query: { code: code } }"
            >
              <div class="more">
                <span>更多</span>
                <i class="iconfont icon-gengduo"></i>
              </div>
            </router-link>
          </div>
          <div class="carouse">
            <div class="no-data" v-if="dataList.length == 0">
              <div>
                <img src="../../assets/img/nodata.png" alt="" />
                <div class="no-data-txt">暂无数据</div>
              </div>
            </div>
            <div
              v-for="(item, index) in dataList"
              :key="index"
              class="carouselItem"
              @click="tongZhiGongGao(item.UnitGuid)"
            >
              <div>
                <img src="~@/assets/img/yuandian_icon.png" />
                <span>{{ item.Title }}</span>
              </div>
              <div>{{ item.AddDate | addDateFormat }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 招标信息 -->
      <div class="zhaoBiaoDaiLiBox">
        <div class="zhaoBiaoDaiLi" style="width: 890px">
          <div class="zbdlTit">
            <div>
              <i class="iconfont icon-zhaobiaodaili"></i>
              <span>招标信息</span>
            </div>
            <div></div>
          </div>
          <div class="zbdlCont2">
            <!-- 交易信息 -->
            <div class="right-cont2">
              <div class="m-navCont first-box">
                <ul class="cont-tit">
                  <li>
                    <span
                      @click="getzbggList(1)"
                      :class="{ active: tabcurFirst == 0 }"
                      >招标公告</span
                    >
                  </li>
                  <li>
                    <span
                      @click="getzgysList(1)"
                      :class="{ active: tabcurFirst == 1 }"
                      >资格预审公告</span
                    >
                  </li>
                  <li>
                    <span
                      @click="getzbhxrList(1)"
                      :class="{ active: tabcurFirst == 2 }"
                      >中标候选人公示</span
                    >
                  </li>
                  <li>
                    <span
                      @click="getzbjgList(1)"
                      :class="{ active: tabcurFirst == 3 }"
                      >中标结果公示</span
                    >
                  </li>
                  <li>
                    <span
                      @click="getgzggList(1)"
                      :class="{ active: tabcurFirst == 4 }"
                      >更正公告</span
                    >
                  </li>
                  <li class="more">
                    <div @click="zhaoBiaoDaiLi">
                      更多
                      <i class="iconfont icon-gengduo"></i>
                    </div>
                  </li>
                </ul>

                <!-- 招标公告 -->
                <div class="navCont" v-show="tabcurFirst == 0">
                  <div class="no-data" v-if="zbggList.length == 0">
                    <div>
                      <img src="../../assets/img/nodata.png" alt="" />
                      <div class="no-data-txt">暂无数据</div>
                    </div>
                  </div>
                  <div
                    class="navList"
                    v-else
                    v-for="(item, index) in zbggList"
                    :key="index"
                    @click="zbDetail(item.unitguid, 1)"
                  >
                    <div>{{ item.noticeName }}</div>
                    <div>{{ item.faBuDate | addDateFormat }}</div>
                  </div>
                </div>
                <!-- 资格预审公告 -->
                <div class="navCont" v-show="tabcurFirst == 1">
                  <div class="no-data" v-if="zgysList.length == 0">
                    <div>
                      <img src="../../assets/img/nodata.png" alt="" />
                      <div class="no-data-txt">暂无数据</div>
                    </div>
                  </div>
                  <div
                    class="navList"
                    v-else
                    v-for="(item, index) in zgysList"
                    :key="index"
                    @click="zgDetail(item.unitguid, 1)"
                  >
                    <div>{{ item.noticeName }}</div>
                    <div>{{ item.faBuDate | addDateFormat }}</div>
                  </div>
                </div>
                <!-- 中标候选人公示 -->
                <div class="navCont" v-show="tabcurFirst == 2">
                  <div class="no-data" v-if="zbhxrList.length == 0">
                    <div>
                      <img src="../../assets/img/nodata.png" alt="" />
                      <div class="no-data-txt">暂无数据</div>
                    </div>
                  </div>
                  <div
                    class="navList"
                    v-else
                    v-for="(item, index) in zbhxrList"
                    :key="index"
                    @click="hxrDetail(item.unitguid, 1)"
                  >
                    <div>{{ item.gongGaoTitle }}</div>
                    <div>{{ item.adddate | addDateFormat }}</div>
                  </div>
                </div>
                <!-- 中标结果公示 -->
                <div class="navCont" v-show="tabcurFirst == 3">
                  <div class="no-data" v-if="zbjgList.length == 0">
                    <div>
                      <img src="../../assets/img/nodata.png" alt="" />
                      <div class="no-data-txt">暂无数据</div>
                    </div>
                  </div>
                  <div
                    class="navList"
                    v-else
                    v-for="(item, index) in zbjgList"
                    :key="index"
                    @click="zbjgDetail(item.unitguid, 1)"
                  >
                    <div>{{ item.gongGaoTitle }}</div>
                    <div>{{ item.adddate | addDateFormat }}</div>
                  </div>
                </div>
                <!-- 更正公告 -->
                <div class="navCont" v-show="tabcurFirst == 4">
                  <div class="no-data" v-if="gzggList.length == 0">
                    <div>
                      <img src="../../assets/img/nodata.png" alt="" />
                      <div class="no-data-txt">暂无数据</div>
                    </div>
                  </div>
                  <div
                    class="navList"
                    v-else
                    v-for="(item, index) in gzggList"
                    :key="index"
                    @click="gzggDetail(item.unitguid, 1)"
                  >
                    <div>{{ item.gongGaoName }}</div>
                    <div>{{ item.faBuDate | addDateFormat }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="zhaoBiaoDaiLiRight">
          <div class="rightItem">
            <div class="rightItemTit">
              <img src="../../assets/img/bianjierk_icon.png" alt="" />
              <span>登录入口</span>
            </div>
            <div class="rightItemCont">
              <div @click="dljgLogin">
                <img src="../../assets/img/kjrk_icon1.png" alt="" />
                <span>代理机构登录</span>
              </div>
              <div @click="tbrLogin">
                <img src="../../assets/img/kjrk_icon2.png" alt="" />
                <span>投标人登录</span>
              </div>
              <div @click="pjzjLogin">
                <img src="../../assets/img/kjrk_icon3.png" alt="" />
                <span>评标专家登录</span>
              </div>
              <div @click="zbrLogin">
                <img src="../../assets/img/kjrk_icon7.png" alt="" />
                <span>招标人登录</span>
              </div>
            </div>
          </div>
          <div class="line-18"></div>
          <div class="rightItem">
            <div class="rightItemTit rightItemTit2">
              <img src="../../assets/img/xiazaizx_icon.png" alt="" />
              <span>下载中心</span>
            </div>
            <div class="rightItemCont">
              <div @click="czsc">
                <img src="../../assets/img/kjrk_icon5.png" alt="" />
                <span>操作手册</span>
              </div>
              <div @click="tbgj">
                <img src="../../assets/img/kjrk_icon6.png" alt="" />
                <span>投标工具</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 政府采购 -->
      <div class="zhaoBiaoDaiLi">
        <div class="zbdlTit">
          <div>
            <i class="iconfont icon-zixunfuwu"></i>
            <span>政府采购</span>
          </div>
          <div></div>
        </div>
        <div class="zbdlCont2">
          <!-- 建设工程 -->
          <div class="right-cont2">
            <!-- 政府采购 -->
            <div class="m-navCont first-box">
              <ul class="cont-tit">
                <li>
                  <span
                    @click="getzbggList(2)"
                    :class="{ active: tabcurSecond == 0 }"
                    >采购信息</span
                  >
                </li>
                <li>
                  <span
                    @click="getzbjgList(2)"
                    :class="{ active: tabcurSecond == 1 }"
                    >采购结果</span
                  >
                </li>
                <li>
                  <span
                    @click="getgzggList(2)"
                    :class="{ active: tabcurSecond == 2 }"
                    >更正公告</span
                  >
                </li>
                <li class="more">
                  <div @click="zhengFuCaiGou">
                    更多
                    <i class="iconfont icon-gengduo"></i>
                  </div>
                </li>
              </ul>
              <!-- 采购信息 -->
              <div class="navCont" v-show="tabcurSecond == 0">
                <div class="no-data" v-if="cgxxList.length == 0">
                  <div>
                    <img src="../../assets/img/nodata.png" alt="" />
                    <div class="no-data-txt">暂无数据</div>
                  </div>
                </div>
                <div
                  class="navList"
                  v-else
                  v-for="(item, index) in cgxxList"
                  :key="index"
                  @click="zbDetail(item.unitguid, 2)"
                >
                  <div>{{ item.noticeName }}</div>
                  <div>{{ item.faBuDate | addDateFormat }}</div>
                </div>
              </div>
              <!-- 采购结果 -->
              <div class="navCont" v-show="tabcurSecond == 1">
                <div class="no-data" v-if="cgjgList.length == 0">
                  <div>
                    <img src="../../assets/img/nodata.png" alt="" />
                    <div class="no-data-txt">暂无数据</div>
                  </div>
                </div>
                <div
                  class="navList"
                  v-else
                  v-for="(item, index) in cgjgList"
                  :key="index"
                  @click="zbjgDetail(item.unitguid, 2)"
                >
                  <div>{{ item.gongGaoTitle }}</div>
                  <div>{{ item.adddate | addDateFormat }}</div>
                </div>
              </div>
              <!-- 更正公告 -->
              <div class="navCont" v-show="tabcurSecond == 2">
                <div class="no-data" v-if="cggzggList.length == 0">
                  <div>
                    <img src="../../assets/img/nodata.png" alt="" />
                    <div class="no-data-txt">暂无数据</div>
                  </div>
                </div>
                <div
                  class="navList"
                  v-else
                  v-for="(item, index) in cggzggList"
                  :key="index"
                  @click="gzggDetail(item.unitguid, 2)"
                >
                  <div>{{ item.gongGaoName }}</div>
                  <div>{{ item.faBuDate | addDateFormat }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 友情链接 -->
      <div class="zhaoBiaoDaiLi">
        <div class="zbdlTit">
          <div>
            <img
              style="margin-right: 8px"
              src="~@/assets/img/title_icon4.png"
              alt=""
            />
            <span>友情链接</span>
          </div>
          <div></div>
        </div>
        <div class="link-box">
          <img src="~@/assets/img/zzzbtlogo.png" @click="openzbt" />
          <img src="~@/assets/img/zzhl.png" @click="zzhl" />

          <!-- <img src="~@/assets/img/zgzbtbggfwpt.png" @click="zgzbtbggfwpt" /> -->
          <img src="~@/assets/img/jsszbtbggfwpt.png" @click="jsszbtbggfwpt" />
          <img src="~@/assets/img/jsszfcglogo.png" @click="openjszfcg" />
          <img src="~@/assets/img/njggxxcgwlogo.png" @click="opennjzfcg" />
          <!-- <img src="~@/assets/img/jtyh.png" @click="jtyh" />
          <img src="~@/assets/img/njzbtb.png" @click="njzbtb" /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getInforList,
  getZhaoBiaoGongGaoList,
  getZiGeYuShenList,
  getHouXuanRenGongShiList,
  getZhongBiaoResultGongShiList,
  getGengZhengGongGaoList,
} from "@/api/index.js";

export default {
  name: "MainContent",
  props: {},
  data() {
    return {
      cur: 0,
      topcur: 0,
      cur1: 0,
      cardInfo: [], //轮播图
      dataList: [], //新闻中心列表
      code: "800002", //新闻中心编码，默认通知公告
      tabcurFirst: 0, //建设工程切换
      tabcurSecond: 0, //政府采购切换
      noticeList: [], //通知公告列表数据
      zbggList: [], //招标公告列表数据
      zgysList: [], //资格预审列表数据
      zbhxrList: [], //中标候选人列表数据
      zbjgList: [], //中标结果公示列表数据
      gzggList: [], //更正公告列表数据
      cgxxList: [], //采购信息列表数据
      cgjgList: [], //采购结果列表数据
      cggzggList: [], //采购更正公告列表数据
    };
  },
  filters: {
    addDateFormat(val) {
      return (val = val.substring(0, 10));
    },
  },
  mounted() {
    this.getSwiper();
    // this.getNotice();
    this.getzbggList(1); // 招标公告列表  1 代表招标项目 2代表政府采购
    this.getzbggList(2); // 招标公告列表  1 代表招标项目 2代表政府采购
    // this.getzgysList(); // 资格预审公告
    // this.getzbhxrList(); // 中标候选人
    // this.getzbjgList(1); // 中标结果公示  1 代表招标项目 2代表政府采购
    // this.getgzggList(1); // 更正公告   1 代表招标项目 2代表政府采购
    this.getList(this.code); //公司动态
  },
  methods: {
    // 轮播图
    getSwiper() {
      let data = {
        ClassCode: "800",
        PageIndex: 1,
        PageSize: 15,
        TenantID: this.$store.state.tenantid,
        IsSlider: 1,
      };
      getInforList(data).then((res) => {
        if (res) {
          this.cardInfo = res.message;
        }
      });
    },
    // 通知公告
    getNotice() {
      let data = {
        ClassCode: "800002",
        PageIndex: 1,
        PageSize: 5,
        TenantID: this.$store.state.tenantid,
        IsSlider: 0,
      };
      getInforList(data).then((res) => {
        if (res) {
          this.noticeList = res.message;
        }
      });
    },
    // 新闻中心切换
    toptabClick(code, index) {
      this.topcur = index;
      this.code = code;
      this.getList(code);
    },
    // 新闻中心列表内容
    getList(code) {
      let data = {
        ClassCode: code,
        PageIndex: 1,
        PageSize: 5,
        TenantID: this.$store.state.tenantid,
        IsSlider: 0,
      };
      getInforList(data).then((res) => {
        if (res) {
          this.dataList = res.message;
        }
      });
    },
    // 招标公告列表
    getzbggList(type) {
      let data = {
        pageIndex: 1,
        pageSize: 5,
        ztbTenantID: this.$store.state.ztbTenantID,
        projectType: type,
      };
      if (type == 1) {
        data.pageSize = 7;
        getZhaoBiaoGongGaoList(data).then((res) => {
          this.zbggList = res.data.rows;
        });
        this.tabcurFirst = 0;
      } else {
        getZhaoBiaoGongGaoList(data).then((res) => {
          this.cgxxList = res.data.rows;
        });
        this.tabcurSecond = 0;
      }
    },
    // 资格预审公告
    getzgysList() {
      this.tabcurFirst = 1;
      let data = {
        pageIndex: 1,
        pageSize: 7,
        ztbTenantID: this.$store.state.ztbTenantID,
      };
      getZiGeYuShenList(data).then((res) => {
        this.zgysList = res.data.rows;
      });
    },
    // 中标候选人
    getzbhxrList() {
      this.tabcurFirst = 2;
      let data = {
        pageIndex: 1,
        pageSize: 7,
        ztbTenantID: this.$store.state.ztbTenantID,
      };
      getHouXuanRenGongShiList(data).then((res) => {
        this.zbhxrList = res.data.rows;
      });
    },
    // 中标结果公示
    getzbjgList(type) {
      let data = {
        pageIndex: 1,
        pageSize: 5,
        ztbTenantID: this.$store.state.ztbTenantID,
        projectType: type,
      };
      if (type == 1) {
        data.pageSize = 7;
        getZhongBiaoResultGongShiList(data).then((res) => {
          this.zbjgList = res.data.rows;
        });
        this.tabcurFirst = 3;
      } else {
        getZhongBiaoResultGongShiList(data).then((res) => {
          this.cgjgList = res.data.rows;
        });
        this.tabcurSecond = 1;
      }
    },
    // 更正公告
    getgzggList(type) {
      let data = {
        pageIndex: 1,
        pageSize: 5,
        ztbTenantID: this.$store.state.ztbTenantID,
        projectType: type,
      };
      if (type == 1) {
        data.pageSize = 7;
        getGengZhengGongGaoList(data).then((res) => {
          this.gzggList = res.data.rows;
        });
        this.tabcurFirst = 4;
      } else {
        getGengZhengGongGaoList(data).then((res) => {
          this.cggzggList = res.data.rows;
        });
        this.tabcurSecond = 2;
      }
    },
    tabClick(cur, type) {
      this.cur = cur;
      if (type == 1) {
        this.getzbggList(type); // 招标公告列表
        this.getzgysList(); // 资格预审公告
        this.getzbhxrList(); // 中标候选人
        this.getzbjgList(type); // 中标结果公示
        this.getgzggList(type); // 更正公告
      } else {
        this.getzbggList(type); // 招标公告列表
        this.getzbjgList(type); // 中标结果公示
        this.getgzggList(type); // 更正公告
      }
    },
    // 通知公告
    tzgg() {
      this.$router.push({
        name: "TongZhiGongGao",
      });
    },
    zhaoBiaoDaiLi() {
      let routeUrl = this.$router.resolve({
        name: "ZhaoBiaoDaiLi",
        query: { type: 1 },
      });
      window.open(routeUrl.href, '_blank');
      // this.$router.push({
      //   name: "ZhaoBiaoDaiLi",
      //   query: { type: 1 },
      // });
    },
    zhengFuCaiGou() {
      let routeUrl = this.$router.resolve({
        name: "ZhaoBiaoDaiLi",
        query: { type: 2 },
      });
      window.open(routeUrl.href, '_blank');
      // this.$router.push({
      //   name: "ZhaoBiaoDaiLi",
      //   query: { type: 2 },
      // });
    },
    tongZhiGongGao(unitguid) {
      let routeUrl = this.$router.resolve({
        name: "DetailInfo",
        query: {
          unitguid: unitguid,
          code: this.code,
        },
      });
      window.open(routeUrl.href, '_blank');
      // this.$router.push({
      //   name: "DetailInfo",
      //   query: {
      //     unitguid: unitguid,
      //     code: this.code,
      //   },
      // });
    },
    // 招标公告详情
    zbDetail(unitguid, type) {
      let routeUrl = this.$router.resolve({
        name: "ZBDLDetailInfo",
        query: {
          unitguid: unitguid,
          style: "getZhaoBiaDetail",
          type,
        },
      });
      window.open(routeUrl.href, '_blank');
      // this.$router.push({
      //   name: "ZBDLDetailInfo",
      //   query: {
      //     unitguid: unitguid,
      //     style: "getZhaoBiaDetail",
      //     type,
      //   },
      // });
    },
    // 资格预审公告详情
    zgDetail(unitguid, type) {
      let routeUrl = this.$router.resolve({
        name: "ZBDLDetailInfo",
        query: {
          unitguid: unitguid,
          style: "getZiGeYuShenDetail",
          type,
        },
      });
      window.open(routeUrl.href, '_blank');
      // this.$router.push({
      //   name: "ZBDLDetailInfo",
      //   query: {
      //     unitguid: unitguid,
      //     style: "getZiGeYuShenDetail",
      //     type,
      //   },
      // });
    },
    // 中标候选人公示详情
    hxrDetail(unitguid, type) {
      let routeUrl = this.$router.resolve({
        name: "ZBDLDetailInfo",
        query: {
          unitguid: unitguid,
          style: "getHouXuanRenGongShiDetail",
          type,
        },
      });
      window.open(routeUrl.href, '_blank');
      // this.$router.push({
      //   name: "ZBDLDetailInfo",
      //   query: {
      //     unitguid: unitguid,
      //     style: "getHouXuanRenGongShiDetail",
      //     type,
      //   },
      // });
    },
    // 中标结果公示详情
    zbjgDetail(unitguid, type) {
      let routeUrl = this.$router.resolve({
        name: "ZBDLDetailInfo",
        query: {
          unitguid: unitguid,
          style: "getZhongBiaoJieGuoDetail",
          type,
        },
      });
      window.open(routeUrl.href, '_blank');
      // this.$router.push({
      //   name: "ZBDLDetailInfo",
      //   query: {
      //     unitguid: unitguid,
      //     style: "getZhongBiaoJieGuoDetail",
      //     type,
      //   },
      // });
    },
    // 更正公告详情
    gzggDetail(unitguid, type) {
      let routeUrl = this.$router.resolve({
        name: "ZBDLDetailInfo",
        query: {
          unitguid: unitguid,
          style: "getGengZhengGongGaoDetail",
          type,
        },
      });
      window.open(routeUrl.href, '_blank');
      // this.$router.push({
      //   name: "ZBDLDetailInfo",
      //   query: {
      //     unitguid: unitguid,
      //     style: "getGengZhengGongGaoDetail",
      //     type,
      //   },
      // });
    },
    zxfwDetail(unitguid) {
      this.$router.push({
        name: "ZXFWDetailInfo",
        query: {
          unitguid: unitguid,
        },
      });
    },
    // 登录入口跳转
    dljgLogin() {
      window.location.href =
        "https://zbt.haopan.net/ztbmanage/XD.Login/Login.aspx?logintype=2&version=20211020";
    },
    tbrLogin() {
      window.location.href =
        "https://zbt.haopan.net/web/website/login.html?version=20211020";
    },
    pjzjLogin() {
      window.location.href =
        "https://zbt.haopan.net/ztbmanage/zhaotoubiaoweb/zhuanjia/zhuanjialogin.html?version=20211020";
    },
    zbrLogin() {
      window.location.href =
        "https://zbt.haopan.net/ztbmanage/XD.Login/Login.aspx?logintype=3&version=20211020";
    },

    // 下载中心跳转
    czsc() {
      window.location.href =
        "https://zbt.haopan.net/web/website/xiaZaiZhongXin/ziLiaoXiaZai_list.html?type=&version=20211020";
    },
    tbgj() {
      window.location.href =
        "https://zbt.haopan.net/web/website/xiaZaiZhongXin/xiaZaiZhongXin_list.html?type=&version=20211020";
    },
    //打开中国招标投标公告服务平台
    zgzbtbggfwpt() {
      window.open("http://www.cebpubservice.com/");
    },
    //打开江苏省招标投标公共服务平台
    jsszbtbggfwpt() {
      window.open("https://jszbtb.com/");
    },
    //打开中招互联
    zzhl() {
      window.open("https://www.ebinterlink.com/");
    },
    //打开交通银行
    jtyh() {
      window.open("http://www.bankcomm.com/");
    },
    //打开南京招标投标云网
    njzbtb() {
      window.open("http://www.njzbtb.com/");
    },
    //打开招标通
    openzbt() {
      window.open("https://zbt.haopan.net/");
    },
    //打开江苏省政府采购网
    openjszfcg() {
      window.open("http://www.ccgp-jiangsu.gov.cn/");
    },
    //打开南京市政府采购网
    opennjzfcg() {
      window.open("https://njgc.jfh.com/");
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/css/pagecss/MainContent.scss";
</style>
